import React, { useEffect, useState } from 'react'
import Header from './components/Header'
import MaterialTable from '@material-table/core'
import * as UIcons from '@iconscout/react-unicons'
import { useDispatch, useSelector } from 'react-redux'
import { withTranslation } from 'react-i18next'
// import Icons from 'includes/Icons'
import { getResponse, previewModal, showModal } from 'store/slices/miscSlice'
import UserPreview from './components/UserPreview'
// import { apiRequest } from 'store/Misc/apiRequest'
import TableActionBtn from 'components/TableActionBtn'
import AddUser from './components/AddUser'
import { UserValidation } from 'pages/Settings/validation'
import Propmt from 'components/Propmt'
import { MenuItem } from '@mui/material'
// import { filterValues } from 'Helper'
// import useSWR from 'swr'
import useUsers from 'hooks/useUsers'
import { FormProvider, useForm } from 'react-hook-form'
// import Input from 'components/Input'
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
import Btn from 'components/Btn'
import Spinner from 'components/Spinner'
import NoUsers from './components/NoUsers'
import { mutate } from 'swr'


export default withTranslation()(function UserManagement({ t }) {
  const { users } = useUsers()
  const [data, setData] = useState()
  // const { data: roles } = useSWR('user-mgmt/roles')
  const [roleId, setRoleId] = useState(null)
  // const [userRoles, setUserRoles] = useState([])
  const dispatch = useDispatch()
  const { response } = useSelector(state => state?.misc)
  // useEffect(() => {
  //   if (Roles?.data) setRoles(Roles.data)
  // }, [Roles]);
  useEffect(() => {
    // console.log(users)
    setData(users?.sort((a, b) => b.id - a.id))
    // if (users) setUserRoles(users?.map(user => user.roles)?.map(x => x?.map(x => x.name)))
  }, [users])

  useEffect(() => { mutate('user-mgmt/users') }, [response])
  // console.log(userRoles)
  const method = useForm({
    mode: 'all'
  })

  const ActiveMsg = ({ id, status, fullname }) => <Propmt
    msg={status === 'suspended' ? t('settings.user_management.form.activate.prompt', { fullname }) : t('settings.user_management.form.ban.prompt', { fullname })}
    successMsg={status === 'suspended' ? t('settings.user_management.form.activate.successMsg') : t('settings.user_management.form.ban.successMsg')}
    url={`pos/${id}/${status === 'suspended' ? 'mark-as-active' : 'mark-as-blocked'}`}
    btnText={status === 'suspended' ? t('settings.user_management.form.activate.text') : t('settings.user_management.form.ban.text')}
  />

  // const showRoleOptions = (id) => alert(id)
  const showRoleOptions = (id) => setRoleId(prevId => prevId !== id ? id : null)

  const switchRole = async (role, id) => {
    showRoleOptions(id)
    // try {
    //   await apiRequest({
    //     method: 'get',
    //     url: `user-mgmt/assign-role-by-name/${id}/${role}`
    //   })
    //   mutate('user-mgmt/roles')
    // } catch ({ message }) {
    //   destructureErrorMessage(message).map(msg => {
    //     return toast.error(msg, { autoClose: 15000 })
    //   })
    // }

  }

  // const options = roles?.data ? filterValues({ options: roles.data, param: { value: 'id', label: 'name' } }) : []

  return (
    <>
      {
        data  ? (
          data.length ? (
            <div className="bg-white rounded-xl mb-10 overflow-hidden p-5">
              {
                data ?
                  <MaterialTable
                    title=''
                    columns={[
                      { title: t('settings.user_management.form.firstname.label'), field: 'first_name' },
                      { title: t('settings.user_management.form.lastname.label'), field: 'last_name' },
                      { title: t('settings.user_management.form.email.label'), field: 'email' },
                      // { title: t('settings.user_management.form.phone.label'), field: 'phone' },
                      {
                        title: t('settings.user_management.roles'),
                        field: 'roles',
                        render: ({ roles, id }) => {
                          // console.log(roles?.map(role => role.name), 'jdjdj')
                          return (<FormProvider {...method}>
                            <div className="relative">
                              {/* <div className="bg-primary bg-opacity-30 flex items-center text-primary rounded-md font-medium text-sm roles"> */}

                              <Btn
                                content={() => <div className="flex w-[100px] justify-between"><span className="mr-1 capitalize">{roles[0]?.name || 'No role'}</span> <UIcons.UilAngleDown /></div>}
                                className="py-2 px-3 bg-primary bg-opacity-30 hover:bg-opacity-40 hover:bg-primary text-primary"
                                click={() => { showRoleOptions(id); }}
                              />

                              {
                                +roleId === +id ? (
                                  <div className="!w-[120px] shadow-lg absolute top-8 rounded-b-lg z-[1000] left-0 bg-white left-0 py-2 px-3">
                                    {roles.length ? (
                                      roles.map((role) => (
                                        <MenuItem key={role.id} value={role.id} className=''
                                          onClick={() => switchRole(role.id, id)}
                                        >
                                          <span className='capitalize'> {role.name} </span>
                                        </MenuItem>
                                      ))
                                    ) : ('No role')}
                                  </div>
                                ) : null
                              }
                            </div>
                          </FormProvider>)
                        }
                      }
                    ]}
                    options={{
                      actionsColumnIndex: -1,
                      pageSize: 5,
                      headerStyle: { fontWeight: '700', fontSize: '14px', color: '#657585' },
                    }}
                    // icons={Icons}
                    actions={[
                      {
                        icon: () => <UIcons.UilEye className="text-primary" />,
                        tooltip: 'View details',
                        onClick: (e, tableProps) => dispatch(previewModal({
                          title: 'User details',
                          content: () => <UserPreview tableProps={tableProps} />
                        }))
                      }
                    ]}
                    // localization={
                    //   header:{
                    //     ac
                    //   }
                    // }
                    data={data ?? []}
                    components={{
                      Toolbar: props => (
                        <>
                          <Header />
                        </>
                      ),
                      Action: ({ data }) => (
                        <>
                          <TableActionBtn
                            data={[
                              {
                                Content: {
                                  // icon: UIcons.UilCodeBranch,
                                  text: t('misc.edit')
                                },
                                action: () => {
                                  dispatch(showModal({
                                    title: t('settings.user_management.edit', { firstname: data.first_name }),
                                    content: () => <AddUser isFromEdit initialValues={data} />,
                                    validation: UserValidation,
                                    method: 'put',
                                    url: `user-mgmt/users/${data.id}`,
                                    successMsg: t('settings.user_management.form.mod_success')
                                  }));
                                  dispatch(getResponse(`edit_user_${data.id}`))
                                }
                              },
                              {
                                Content: {
                                  text: data.status === 'suspended' ? t('settings.user_management.form.activate.text') : t('settings.user_management.form.ban.text'),
                                  classList: data.status === 'suspended' ? 'text-green' : 'text-failure'
                                },
                                action: () => {
                                  dispatch(previewModal({
                                    title: data.status === 'suspended' ? `${t('settings.user_management.form.activate.text')} ${t('pos.pos')}` : `${t('settings.user_management.form.ban.text')} ${t('pos.pos')}`,
                                    content: () => <ActiveMsg id={data.id} status={data.status} fullname={`${data.first_name} ${data.last_name}`} />
                                  }))
                                }
                              },
                            ]}
                          />
                        </>
                      )
                    }}
                  /> : <Spinner />
              }
            </div>
          ) : (<NoUsers />)
        ) : (
          <Spinner />
        )
      }
    </>
  )
})


// const users = [
//   {
//     "id": 1,
//     "first_name": "John",
//     "last_name": "Doe",
//     "email": "john_doe@gmail.com",
//     "merchant_id": 1,
//     "phone": "+233248764986",
//     "email_verified_at": "2021-12-03T21:05:40.000000Z",
//     "phone_verified_at": "2021-12-03T21:05:40.000000Z",
//     "status": "active",
//     "avatar": null,
//     "suspended_until": null,
//     "last_updated_by": null,
//     "last_deleted_by": null,
//     "created_at": "2021-12-03T21:05:40.000000Z",
//     "updated_at": "2021-12-03T21:05:40.000000Z",
//     "roles": []
//   },
//   {
//     "id": 2,
//     "first_name": "Frank",
//     "last_name": "James",
//     "email": "james@gmail.com",
//     "merchant_id": 1,
//     "phone": "+233247545662",
//     "email_verified_at": "2021-12-03T21:05:42.000000Z",
//     "phone_verified_at": "2021-12-03T21:05:42.000000Z",
//     "status": "active",
//     "avatar": null,
//     "suspended_until": null,
//     "last_updated_by": null,
//     "last_deleted_by": null,
//     "created_at": "2021-12-03T21:05:42.000000Z",
//     "updated_at": "2021-12-03T21:05:42.000000Z",
//     "roles": []
//   },
//   {
//     "id": 3,
//     "first_name": "Nathan",
//     "last_name": "Luck",
//     "email": "nate@gmail.com",
//     "merchant_id": 1,
//     "phone": "+233249149420",
//     "email_verified_at": null,
//     "phone_verified_at": null,
//     "status": "active",
//     "avatar": null,
//     "suspended_until": null,
//     "last_updated_by": null,
//     "last_deleted_by": null,
//     "created_at": "2021-12-07T10:39:53.000000Z",
//     "updated_at": "2021-12-07T10:39:53.000000Z",
//     "roles": []
//   },
//   {
//     "id": 15,
//     "first_name": "Raymond",
//     "last_name": "Awase",
//     "email": "ray@gmail.com",
//     "merchant_id": 1,
//     "phone": "0242348882",
//     "email_verified_at": null,
//     "phone_verified_at": null,
//     "status": "active",
//     "avatar": null,
//     "suspended_until": null,
//     "last_updated_by": null,
//     "last_deleted_by": null,
//     "created_at": "2022-02-12T08:34:03.000000Z",
//     "updated_at": "2022-02-12T08:34:03.000000Z",
//     "roles": []
//   },
//   {
//     "id": 16,
//     "first_name": "Justice",
//     "last_name": "Authur",
//     "email": "justicea83+merchant1@gmail.com",
//     "merchant_id": 1,
//     "phone": "0244564353",
//     "email_verified_at": null,
//     "phone_verified_at": null,
//     "status": "active",
//     "avatar": null,
//     "suspended_until": null,
//     "last_updated_by": null,
//     "last_deleted_by": null,
//     "created_at": "2022-02-16T21:47:05.000000Z",
//     "updated_at": "2022-02-16T21:47:05.000000Z",
//     "roles": []
//   }
// ]